import request, { serviceV2 } from '@/utils/request'

const prefix = '/django_rest/agency'

export default {
  getResumeDownloadUrl (jobId, candidateId, params) {
    return serviceV2.get(`/agency/application/job/${jobId}/candidate/${candidateId}/resume-download/`, { params })
  },
  getApplicationResumeInfo (params) {
    return request.get(`${prefix}/candidate/${params.jobId}/`, { params })
  },
  createCandidateByJob (params) {
    return request.post(`${prefix}/candidate/${params.jobId}/`, params)
  },
  updateCandidateInfo (params) {
    return request.put(`${prefix}/candidate/${params.jobId}/`, params)
  },
  headhunterUploadCandidatePhoto (candidateId, jobId, photo) {
    const formData = new FormData()
    formData.append('photo', photo)
    if (jobId !== null && jobId !== undefined) {
      formData.append('job_id', jobId)
    }
    return request.post(`${prefix}/candidate/${candidateId}/photo/`, formData)
  },
  getAgencyList (params) {
    return request.get(`${prefix}/list/`, { params })
  },
  shareJobToAgency (params) {
    return request.post(`${prefix}/share-job/`, params)
  },
  getJobInfoByJobId (jobId) {
    return request.get(`${prefix}/job/${jobId}/`)
  },
  getAgencyJobInfo (jobId) {
    return request.get(`${prefix}/job/${jobId}/job-info/`)
  },
  getAgencyJobList (params) {
    return request.get(`${prefix}/job-list/`, { params })
  },
  getAgencyJobCompanyList (params) {
    return request.get(`${prefix}/has-assign-job-company-list/`, { params })
  },
  getAgencyJobApplicationList (jobId, params) {
    return request.get(`${prefix}/job/${jobId}/application/`, { params })
  },
  getApplicationIdList (params) {
    return request.get(`${prefix}/job/${params.job_id}/application-ids/`, { params })
  },
  getCopyCandidateJobList (params) {
    return request.get(`${prefix}/copy-candidate/`, { params })
  },
  getAgencyInfoById (agencyId) {
    return request.get(`${prefix}/${agencyId}/`)
  },
  createAgency (agencyInfo) {
    return request.post(`${prefix}/add/`, agencyInfo)
  },
  updateAgency (agencyInfo) {
    return request.put(`${prefix}/edit/${agencyInfo.agency_id}/`, agencyInfo)
  }
}
